import { useQuery } from '@tanstack/react-query';
import { checkSession } from '../api/auth';

/**
 * Hook that checks the current Frappe session.
 * Returns { user, isLoading, isError, error }.
 *
 * Uses React Query with a 5-minute staleTime so we don't
 * re-check on every render / navigation.
 */
export default function useSession() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['session'],
    queryFn: checkSession,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 0, // don't serve stale session across logouts/reloads
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    user: data?.user ?? null,
    isLoading,
    isError,
    error,
  };
}
